// =================================================================
// Store: Combined Zustand store (PSD §9 / TODO Task 1.14, CC.1)
// Composes all slices into a single store.
// =================================================================
import { create } from 'zustand';
import { createPatientSlice } from './patientSlice';
import { createStrategySlice } from './strategySlice';
import { createRegimenSlice } from './regimenSlice';
import { createLevelsSlice } from './levelsSlice';
import { createMonitoringSlice } from './monitoringSlice';
import { createSettingsSlice } from './settingsSlice';
import { createSessionSlice } from './sessionSlice';
import { createDemoSlice } from './demoSlice';
import type { StoreState } from './types';

export const useStore = create<StoreState>((...args) => ({
  ...createPatientSlice(...args),
  ...createStrategySlice(...args),
  ...createRegimenSlice(...args),
  ...createLevelsSlice(...args),
  ...createMonitoringSlice(...args),
  ...createSettingsSlice(...args),
  ...createSessionSlice(...args),
  ...createDemoSlice(...args),
}));

export type { StoreState };
